<template>
  <div class="check" v-show="ksShow">
	<!-- 视频弹框组件 -->

    <div class="status">
      <img src="/static/images/new/ywc_ks.png" width="327px" height="160px">
      <div style="font-size: 20px; font-weight: 500; color: #000000;margin-top: 15px;" v-if="lxKsgn == 1">您已完成规定学时,祝您考试顺利!</div>
      <h3 v-else>您已完成规定学时</h3>
      <p v-show="lxKsgn == 1">考试时间为60分钟，一旦参加考试不可中途退出，否则考试视为作废，请您认真答题</p>
      <div @click="goBackVideo" class="back">继续观看</div>
      <div v-show="lxKsgn == 1" class="join" @click="joinExam()">参加考试</div>
    </div>
  </div>
</template>

<script>
  import { cookie } from "@/common/js/cookies.js";
  export default {
    name: "check",
    props:['kclx','lxKsgn'],
    data() {
      return {
        Data: null,
        Data1: null,
        dialogVisible: false,
        state : -1,
        qyId: null,
        ksShow: false,
      }
    },
    mounted() {

    },
    methods: {
      //返回观看视频
      goBackVideo(){
        this.ksShow = false;
        this.$emit('backGoVideo');
      },
      joinExam : function(){//参加考试
        let _self = this;
        _self.$confirm('考试时间为60分钟，是否现在开始考试？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let ajax = _self.$http.create();
          let data = {
            lxId: this.kclx
          };
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          ajax({
            method: 'post',
            url: SOWINURL + 'XxKh/GeneratTestPapers',
            data: data,
			headers:{
				'token': cookie.get("xyxf_token_qt")
			}
          }).then(function (json) {
            if (json.data.result == 1) {
              // _self.Data = json.data.data;
              _self.$router.push({
                path: '/exam',
                query:{
                  lxId:_self.kclx},
                });
            } else {
              _self.$message({
                showClose: true,
                message: json.data.errorcode,
                type: 'error'
              });
            }
            loading.close();

          }).catch(function (error) {
			loading.close();
            console.log(error);
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
		  _self.ksShow = false
        });
      },
    },
  }
</script>

<style scoped lang="less" type="text/less">
  .check{
	  // position: fixed;
	  // width: 100%;
	  // height: 100%;
	  // top: 90px;
	  // left: 0;
	  // z-index: 10;
  }
  .status {
    padding-top: 150px;
	width: 1300px;
	margin: auto;
    background: #fff;
    text-align: center;
    padding-bottom: 200px;
    .back {
		width: 210px;
		height: 45px;
		border-radius: 8px;
		border: 1px solid rgba(0, 134, 255, 0.69);
		text-align: center;
		color: #2287FF;
		line-height: 45px;
		display: inline-block;
		margin-right: 10px;
	}
	.join {
      width: 210px;
      height: 45px;
      background: #2287FF;
      border-radius: 8px;
	  color: #fff;
	  line-height: 45px;
	  text-align: center;
	  display: inline-block;
	  margin-left: 10px;
	  cursor: pointer;
    }

    

    img {
      display: block;
      margin: 0 auto;
    }

    h3 {
      height: 90px;
      line-height: 90px;
      text-align: center;
      font-size: 30px;
      color: #02113a;
    }

    p {
      margin-top: 20px;
      text-align: center;
      font-size: 16px;
      color: #777C94;
      margin-bottom: 100px;
    }
  }
  .exam{
    padding: 50px 100px;
    background: #fff;
    margin-bottom: 20px;

  }
</style>



// WEBPACK FOOTER //
// src/components/exam/ksts.vue